import React from 'react';
import BankTransferModal from '../Page/Setting/BankTransferModal';
import MomoPopup from '../Page/Setting/MomoPopup';
import MomoPersonalPopup from 'Page/Setting/MomoPersonalPopup';
import MomoBusinessPopup from 'Page/Setting/MomoBusinessPopup';
import { BiWallet, BiCreditCard, BiBarcode, BiDollarCircle, BiMoney, BiBuildingHouse, BiCreditCardFront } from 'react-icons/bi';

export const SETTING = "SETTING"

export const PAYMENT_TYPE_STATE = {
  CASH: 1, // Thanh toán bằng tiền mặt
  BANK_TRANSFER: 2, // Chuyển tiền qua tài khoản ngân hàng
  VNPAY_PERSONAL: 3, // Chuyển tiền qua VNPAY
  CREDIT_CARD: 4, // Thanh toán bằng thẻ tín dụng
  MOMO_PERSONAL: 5, // Chuyển tiền qua MoMo
  ATM_TRANSFER: 6, // Thanh toán bằng thẻ nội địa (ATM)
  MOMO_BUSINESS: 7, // Thanh toán qua MoMo
  ZALOPAY_PERSONAL:8, // Chuyển tiền qua Zalo
  VIETTELPAY_PERSONAL:9, // Chuyển tiền qua Viettelpay
  ZALOPAY_BUSINESS: 10, // Thanh toán qua ZaloPay
  BAOKIM_BUSINESS: 11, // Thanh toán qua Bảo Kim
  KIMNGAN_BUSINESS: 12, // Thanh toán qua Kim Ngân
}

export const optionPaymentTypes = (translation) => {
  return [
    {
      value: PAYMENT_TYPE_STATE.CASH,
      label: translation("setting.payment.options.cash"),
      icon: <div style={{ width: '40px', height: '40px', background: "#EBEBEB"}} className='d-flex align-items-center justify-content-center'><BiDollarCircle className="w-icon" style={{ fontSize: 40 }}/></div>,
    },
    {
      value: PAYMENT_TYPE_STATE.BANK_TRANSFER,
      label: translation("setting.payment.options.bankTransfer"),
      icon: <div style={{ width: '40px', height: '40px', background: "#EBEBEB"}} className='d-flex align-items-center justify-content-center'><BiBuildingHouse className="w-icon" style={{ fontSize: 40 }} /></div>,
      modalComponent: BankTransferModal,
    },
    {
      value: PAYMENT_TYPE_STATE.VNPAY_PERSONAL,
      label: translation("setting.payment.options.vnPay"),
      icon: <div style={{ width: '40px', height: '40px', background: "#EBEBEB"}} className='d-flex align-items-center justify-content-center'><BiWallet className="w-icon" style={{ fontSize: 40 }} /></div>
    },
    {
      value: PAYMENT_TYPE_STATE.MOMO_PERSONAL,
      label: translation("setting.payment.options.momoPersonal"),
      icon: <div style={{ width: '40px', height: '40px', background: "#EBEBEB"}} className='d-flex align-items-center justify-content-center'><BiWallet className="w-icon" style={{ fontSize: 40 }} /></div>,
      modalComponent: MomoPersonalPopup,
    },
    {
      value: PAYMENT_TYPE_STATE.MOMO_BUSINESS,
      label: translation("setting.payment.options.momoBusiness"),
      icon: <div style={{ width: '40px', height: '40px', background: "#EBEBEB"}} className='d-flex align-items-center justify-content-center'><BiMoney className="w-icon" style={{ fontSize: 40 }} /></div>,
      modalComponent: MomoBusinessPopup,
    },
    {
      value: PAYMENT_TYPE_STATE.ATM_TRANSFER,
      label: translation("setting.payment.options.domesticcard"),
      icon: <div style={{ width: '40px', height: '40px', background: "#EBEBEB"}} className='d-flex align-items-center justify-content-center'><BiCreditCardFront className="w-icon" style={{ fontSize: 40 }} /></div>,
      dependent : PAYMENT_TYPE_STATE.MOMO_BUSINESS,
      disabled : true,
    },
    {
      value: PAYMENT_TYPE_STATE.CREDIT_CARD,
      label: translation("setting.payment.options.visaMasterJcb"),
      icon: <div style={{ width: '40px', height: '40px', background: "#EBEBEB"}} className='d-flex align-items-center justify-content-center'><BiCreditCard className="w-icon" style={{ fontSize: 40 }} /></div>,
      dependent : PAYMENT_TYPE_STATE.MOMO_BUSINESS,
      disabled: true,
    },
    {
      value: PAYMENT_TYPE_STATE.ZALOPAY_PERSONAL,
      label: translation("expand_setting.ZALOPAY_PERSONAL"),
      icon: <div style={{ width: '40px', height: '40px', background: "#EBEBEB"}} className='d-flex align-items-center justify-content-center'><BiWallet className="w-icon" style={{ fontSize: 40 }} /></div>,
    },
    {
      value: PAYMENT_TYPE_STATE.VIETTELPAY_PERSONAL,
      label: translation("expand_setting.VIETTELPAY_PERSONAL"),
      icon: <div style={{ width: '40px', height: '40px', background: "#EBEBEB"}} className='d-flex align-items-center justify-content-center'><BiWallet className="w-icon" style={{ fontSize: 40 }} /></div>,
    },
    {
      value: PAYMENT_TYPE_STATE.BAOKIM_BUSINESS,
      label: translation("setting.payment.options.baoKimBusiness"),
      icon: <div style={{ width: '40px', height: '40px', background: "#EBEBEB"}} className='d-flex align-items-center justify-content-center'><BiWallet className="w-icon" style={{ fontSize: 40 }} /></div>,
    },
    {
      value: PAYMENT_TYPE_STATE.KIMNGAN_BUSINESS,
      label: translation("setting.payment.options.kimNganBusiness"),
      icon: <div style={{ width: '40px', height: '40px', background: "#EBEBEB"}} className='d-flex align-items-center justify-content-center'><BiWallet className="w-icon" style={{ fontSize: 40 }} /></div>,
    }
  ];
};

export const optionServiceType = (translation) => [
  {
    value: 1,
    label: translation("serviceTypes.checkingViolation"),
    servicePrice: 0,
  },
  {
    value: 2,
    label: translation("serviceTypes.createTagVetc"),
    servicePrice: 0,
  },
  {
    value: 3,
    label: translation("serviceTypes.payViolationFee"),
    servicePrice: 0,
  },
  {
    value: 4,
    label: translation("serviceTypes.extendInsuranceTnds"),
    servicePrice: 0,
  },
  {
    value: 5,
    label: translation("serviceTypes.payVetcFee"),
    servicePrice: 0,
  },
  {
    value: 6,
    label: translation("serviceTypes.extendIssuranceBody"),
    servicePrice: 0,
  },
  {
    value: 7,
    label: translation("serviceTypes.repairService"),
    servicePrice: 0,
  },
  {
    value: 8,
    label: translation("serviceTypes.inspectCar"),
    servicePrice: 0,
  },
  {
    value: 9,
    label: translation("serviceTypes.payEpassFee"),
    servicePrice: 0,
  },
  {
    value: 10,
    label: translation("serviceTypes.helpService"),
    servicePrice: 0,
  },
  {
    value: 11,
    label: translation("serviceTypes.consultationImprovement"),
    servicePrice: 0,
  },
  {
    value: 12,
    label: translation("serviceTypes.autoNotifyViolation"),
    servicePrice: 0,
  },
  {
    value: 13,
    label: translation("serviceTypes.vehicleInspection"),
    servicePrice: 0,
  },
  {
    value: 14,
    label: translation("serviceTypes.registerNewVehicle"),
    servicePrice: 0,
  },
  {
    value: 15,
    label: translation("serviceTypes.changeRegistration"),
    servicePrice: 0,
  },
  {
    value: 16,
    label: translation("serviceTypes.payRoadFee"),
    servicePrice: 0,
  },
  {
    value: 18,
    label: translation("serviceTypes.consultantMaintenance"),
    servicePrice: 0,
  },
  {
    value: 19,
    label: translation("serviceTypes.consultantInsurance"),
    servicePrice: 0,
  },
  {
    value: 20,
    label: translation("serviceTypes.lostRegistrationPaper"),
    servicePrice: 0,
  },
  {
    value: 21,
    label: translation("serviceTypes.reissueInspectionSticker"),
    servicePrice: 0,
  },
  {
    value: 22,
    label: translation("serviceTypes.vehicleInspectionConsultation"),
    servicePrice: 0,
  },
  {
    value: 23,
    label: translation("serviceTypes.trafficFineConsultation"),
    servicePrice: 0,
  },
  {
    value: 24,
    label: translation("serviceTypes.consultantTndsInsurance"),
    servicePrice: 0,
  },
  {
    value: 25,
    label: translation("serviceTypes.autoNotifyViolationCheck"),
    servicePrice: 0,
  },
  {
    value: 26,
    label: translation("serviceTypes.supportFineResolution"),
    servicePrice: 0,
  },
  {
    value: 27,
    label: translation("serviceTypes.gpsRenewal"),
    servicePrice: 0,
  },
  {
    value: 28,
    label: translation("serviceTypes.businessVehicleBadgeRenewal"),
    servicePrice: 0,
  },
  {
    value: 29,
    label: translation("serviceTypes.trainingCertificateRenewal"),
    servicePrice: 0,
  },
  {
    value: 30,
    label: translation("serviceTypes.dashcamRenewal"),
    servicePrice: 0,
  },
  {
    value: 31,
    label: translation("serviceTypes.tndsInsuranceRenewal"),
    servicePrice: 0,
  },
  {
    value: 32,
    label: translation("serviceTypes.offHourNewVehicleRegister"),
    servicePrice: 0,
  },
  {
    value: 33,
    label: translation("serviceTypes.offHourVehicleInspection"),
    servicePrice: 0,
  },
  {
    value: 34,
    label: translation("serviceTypes.driverHealth"),
    servicePrice: 0,
  },
  {
    value: 35,
    label: translation("serviceTypes.consultantInsuranceCompensation"),
    servicePrice: 0,
  },
  {
    value: 36,
    label: translation("serviceTypes.entryTicket"),
    servicePrice: 0,
  },
  {
    value: 37,
    label: translation("serviceTypes.bridgeTicket"),
    servicePrice: 0,
  },
  {
    value: 38,
    label: translation("serviceTypes.singleUseTicket"),
    servicePrice: 0,
  },
  {
    value: 39,
    label: translation("serviceTypes.carCare"),
    servicePrice: 0,
  },
  {
    value: 40,
    label: translation("serviceTypes.carWash"),
    servicePrice: 0,
  },
];

